import { FC, useMemo } from 'react'
import { Facet } from '@ucheba/ui/components/Facet/desktop'
import { EQueryKeysByFacetName } from '@ucheba/store/institutions/programs/types'
import { IProgramsPageFacets } from '../types'
import ProgramsPagePriceFacet from './ProgramsPagePriceFacet'
import ProgramsPageAcademicHoursFacet from './ProgramsPageAcademicHoursFacet'
import { useExamsWithIcons } from '../bll'
import { extraFacets, types } from '../constants'

const ProgramsPageFacets: FC<IProgramsPageFacets> = (props) => {
  const { facets, onSubmit, programType } = props

  const RadioAllRubric = (
    <Facet
      isRadio
      items={[
        {
          name: 'Все рубрики',
          value: '',
          count: 1,
        },
      ]}
      controlName={EQueryKeysByFacetName.tags}
      onSubmit={onSubmit(EQueryKeysByFacetName.tags)}
      spacing='xsmall'
    />
  )

  const exams = useExamsWithIcons(facets.examSubjects)

  // скидки пока не делаем
  // const saleFacet = useMemo(() => {
  //   return types.course.includes(programType) || types.mba.includes(programType)
  // }, [programType])

  const withoutExams = useMemo(() => {
    return types.vocational.includes(programType)
  }, [programType])

  return (
    <>
      {facets.tags && (
        <>
          <Facet
            isRadio
            isForcedArray
            items={facets.tags}
            title='Рубрика'
            controlName={EQueryKeysByFacetName.tags}
            maxItems={5}
            onSubmit={onSubmit(EQueryKeysByFacetName.tags)}
            afterTitleElement={RadioAllRubric}
          />
        </>
      )}

      {facets.formats && (
        <Facet
          items={facets.formats}
          title='Формат'
          controlName={EQueryKeysByFacetName.formats}
          onSubmit={onSubmit(EQueryKeysByFacetName.formats)}
        />
      )}

      {facets.trainingFormTypes && (
        <Facet
          items={facets.trainingFormTypes}
          title='Форма обучения'
          controlName={EQueryKeysByFacetName.trainingFormTypes}
          onSubmit={onSubmit(EQueryKeysByFacetName.trainingFormTypes)}
        />
      )}

      {facets.programTypes && (
        <Facet
          items={facets.programTypes}
          title='Тип программы'
          controlName={EQueryKeysByFacetName.programTypes}
          onSubmit={onSubmit(EQueryKeysByFacetName.programTypes)}
        />
      )}

      {/* скидки пока не делаем */}
      {/* {saleFacet && ( */}
      {/*  <Facet */}
      {/*    items={extraFacets.sale} */}
      {/*    controlName={EQueryKeysByFacetName.sale} */}
      {/*    onSubmit={onSubmit(EQueryKeysByFacetName.sale)} */}
      {/*    fontWeight='bold' */}
      {/*  /> */}
      {/* )} */}

      {withoutExams && (
        <Facet
          items={extraFacets.hasAdditionalExam}
          controlName={EQueryKeysByFacetName.withoutExams}
          onSubmit={onSubmit(EQueryKeysByFacetName.withoutExams)}
          fontWeight='bold'
        />
      )}

      {facets.price && facets.price.min && facets.price.max && (
        <>
          <ProgramsPagePriceFacet {...facets.price} />
        </>
      )}

      {facets.examSubjects && (
        <Facet
          items={exams}
          title='Экзамены'
          controlName={EQueryKeysByFacetName.examSubjects}
          onSubmit={onSubmit(EQueryKeysByFacetName.examSubjects)}
        />
      )}

      {facets.durationTypes && (
        <Facet
          items={facets.durationTypes}
          title='Длительность'
          controlName={EQueryKeysByFacetName.durationTypes}
          onSubmit={onSubmit(EQueryKeysByFacetName.durationTypes)}
        />
      )}

      {facets.academicHours && facets.academicHours.min && facets.academicHours.max && (
        <>
          <ProgramsPageAcademicHoursFacet {...facets.academicHours} />
        </>
      )}
    </>
  )
}

export default ProgramsPageFacets
